import gettingStarted from "./getting-started.data";
import transparencyTools from "./transparency-tools.data";

const tours = [
  {
    active: true,
    id: "getting-started",
    order: 0,
    steps: gettingStarted,
    force: true,
    start: (navigate) => {
      navigate("/");
    },
    cleanup: (navigate, finish) => {
      navigate("/");
      setTimeout(() => finish(), 100);
    },
  },
  {
    active: true,
    id: "transparency-tools",
    order: 1,
    steps: transparencyTools,
    cleanup: (navigate, finish) => {
      navigate("/");
      setTimeout(() => finish(), 100);
    },
  },
];

export default tours;
